import { isArrayLength } from './genericHelpers';
import { createResourceLocatorString } from './routes';
import { parse } from './urlHelpers';

export const mergeConversationMessages = (threadMessages = [], fetchedMessages = []) => {
  const byId = new Map();
  [...(threadMessages || []), ...(fetchedMessages || [])].forEach(message => {
    const id = message?.id?.uuid || message?.id;
    if (id) byId.set(id, message);
  });
  return [...byId.values()].sort(
    (a, b) => new Date(a.attributes?.createdAt || 0) - new Date(b.attributes?.createdAt || 0)
  );
};

export const scrollToMessage = messageId => {
  if (!messageId?.uuid) return;
  const selector = `#msg-${messageId.uuid}`;
  const el = document.querySelector(selector);
  if (el) {
    el.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
    });
  }
};

export const onSendMessageFormFocus = isSafMobile => {
  if (isSafMobile) {
    typeof window !== 'undefined' &&
      window.scroll({ top: document.body.scrollHeight, left: 0, behavior: 'smooth' });
  }
};

export const navigateToTab = ({ history, routeConfiguration, tabName, pageName, setActiveTab }) => {
  const path = createResourceLocatorString(pageName, routeConfiguration, { tab: tabName }, {});

  history.push(path);
  setActiveTab(tabName);
};

export const createMessagesThreadPath = ({ routes, transactionId, tab = 'order' }) => {
  const transactionUuid =
    typeof transactionId === 'string' ? transactionId : transactionId?.uuid || null;

  return createResourceLocatorString(
    'MessagesPage',
    routes,
    { tab },
    transactionUuid ? { transactionId: transactionUuid } : {}
  );
};

export const getRequestedTransactionId = search => {
  const { transactionId } = parse(search);
  return typeof transactionId === 'string' && transactionId.trim().length > 0
    ? transactionId.trim()
    : null;
};

export const getOtherUser = (transactions, currentUser) => {
  if (!isArrayLength(transactions) || !currentUser?.id) return null;
  return transactions?.map(transaction => {
    const customerId = transaction?.customer?.id?.uuid;
    const isOwnTransaction = customerId === currentUser?.id?.uuid;

    return isOwnTransaction ? transaction?.provider : transaction?.customer;
  });
};
export const getAllMessages = transactions => {
  if (!Array.isArray(transactions) || !isArrayLength(transactions)) {
    return [];
  }

  return transactions?.map(transaction => transaction?.messages).filter(Boolean);
};

const normalizeSearchText = value => (typeof value === 'string' ? value.trim().toLowerCase() : '');

const collectUserSearchValues = user => {
  const profile = user?.attributes?.profile;
  const publicData = profile?.publicData;

  return [
    profile?.displayName,
    profile?.abbreviatedName,
    publicData?.storeName,
    publicData?.sellerName,
    publicData?.providerName,
  ];
};

const collectListingSearchValues = listing => {
  const attributes = listing?.attributes;
  const publicData = attributes?.publicData;

  return [attributes?.title, publicData?.title, publicData?.name, publicData?.listingName];
};

const collectMessageSearchValues = transaction =>
  (Array.isArray(transaction?.messages) ? transaction.messages : []).map(
    message => message?.attributes?.content
  );

export const getTransactionSearchText = transaction => {
  const searchValues = [
    ...collectListingSearchValues(transaction?.listing),
    ...collectUserSearchValues(transaction?.provider),
    ...collectUserSearchValues(transaction?.customer),
    ...collectUserSearchValues(transaction?.seller),
    ...collectMessageSearchValues(transaction),
  ];

  return searchValues
    .map(normalizeSearchText)
    .filter(Boolean)
    .join('\n');
};

export const filterTransactionsBySearchValue = (transactions, searchValue) => {
  const normalizedSearchValue = normalizeSearchText(searchValue);

  if (!normalizedSearchValue) {
    return transactions;
  }

  return (Array.isArray(transactions) ? transactions : []).filter(transaction =>
    getTransactionSearchText(transaction).includes(normalizedSearchValue)
  );
};
